import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePageInit } from '../hooks/usePageInit';
import './RegisterPage.css';

// ストアURL（LP内の Footer / LandingPage と同一の実IDを使用）
const IOS_APP_STORE_URL = 'https://apps.apple.com/jp/app/lessonmate/id6751098543';
const ANDROID_PLAY_URL =
  'https://play.google.com/store/apps/details?id=inc.ludicrous.lessonmate';

export default function RegisterPage() {
  usePageInit();
  const [params] = useSearchParams();
  const schoolId = params.get('schoolId') || '';
  const schoolNameParam = params.get('schoolName') || '';
  const [schoolName, setSchoolName] = useState(schoolNameParam || '教室');

  const appUrl = useMemo(() => {
    const qs = `schoolId=${encodeURIComponent(schoolId)}&schoolName=${encodeURIComponent(schoolName)}`;
    return `lessonmate://register?${qs}`;
  }, [schoolId, schoolName]);

  // クエリに教室名が無い場合はAPIから補完
  useEffect(() => {
    if (schoolNameParam || !schoolId) return;
    (async () => {
      try {
        const res = await fetch(`/api/schools/${encodeURIComponent(schoolId)}`);
        if (!res.ok) return;
        const data = await res.json();
        const name = data?.school?.schoolName || data?.schoolName;
        if (name) setSchoolName(name);
      } catch {
        /* noop */
      }
    })();
  }, [schoolId, schoolNameParam]);

  // 到達時にアプリを開く（インストール済みならアプリへ、未インストールなら何も起きない）
  useEffect(() => {
    if (!schoolId) return;
    const t = setTimeout(() => {
      window.location.href = appUrl;
    }, 400);
    return () => clearTimeout(t);
  }, [appUrl, schoolId]);

  return (
    <div className="register-page">
      <div className="register-card">
        <div className="register-accent" />
        <img className="register-logo" src="/assets/images/app-icon.svg" alt="LessonMate" />
        <p className="register-kicker">教室への登録のご案内</p>
        <h1 className="register-school">{schoolName}</h1>
        {schoolId ? (
          <>
            <p className="register-lead">
              LessonMateアプリで「{schoolName}」に登録します。下のボタンからアプリを開いてください。
            </p>
            <a className="register-btn register-btn--primary" href={appUrl}>
              アプリで開いて登録する
            </a>
            <p className="register-sub">アプリをお持ちでない方はこちら</p>
            <div className="register-stores">
              <a href={IOS_APP_STORE_URL} target="_blank" rel="noreferrer">
                <img className="register-badge" src="/assets/images/mobile/app-store.png" alt="App Store" />
              </a>
              <a href={ANDROID_PLAY_URL} target="_blank" rel="noreferrer">
                <img className="register-badge" src="/assets/images/mobile/play-store.png" alt="Google Play" />
              </a>
            </div>
          </>
        ) : (
          <p className="register-lead">リンクが正しくありません。教室から届いたリンクを再度ご確認ください。</p>
        )}
        <div className="register-footer">Powered by LessonMate</div>
      </div>
    </div>
  );
}
